import { useEffect } from 'react';
import { ExperiencePerformanceTypes, ExperienceTypes, UFOExperience } from '@atlaskit/ufo';

export const shareDialogLoadingExp = new UFOExperience('render-jira-share-dialog', {
	type: ExperienceTypes.Experience,
	performanceType: ExperiencePerformanceTypes.PageSegmentLoad,
});

export const useShareDialogLoadingSuccess = () => {
	useEffect(() => {
		shareDialogLoadingExp.success();
	}, []);
};
